// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const FigmaDownloadIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M14 10v2.667A1.334 1.334 0 0 1 12.667 14H3.333A1.334 1.334 0 0 1 2 12.667V10" stroke={stroke} strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.667 6.667 8 10l3.333-3.333" stroke={stroke} strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10V2" stroke={stroke} strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export { FigmaDownloadIcon };
